import Scan from "./scan";
export default Scan